import { Link } from "react-router-dom";

export default function Cookie() {
  return (
    <div className="legal-page">
      <div className="container legal-content">
        <h1>Cookie Policy</h1>

        <Link to="/" className="back-home">
          &larr; Torna alla home
        </Link>

        <p>
          Questo sito utilizza esclusivamente cookie tecnici necessari al
          funzionamento e alla sicurezza della navigazione.
        </p>

        <h2>Cosa sono i cookie tecnici</h2>
        <p>
          Sono piccoli file che permettono al sito di funzionare correttamente,
          ad esempio mantenendo impostazioni di base e stabilit&agrave; della sessione.
        </p>

        <h2>Cookie di profilazione e marketing</h2>
        <p>
          Al momento non utilizziamo cookie di profilazione o strumenti
          pubblicitari di terze parti.
        </p>

        <h2>Analisi statistiche</h2>
        <p>
          Eventuali strumenti di analisi non tecnici verranno introdotti solo
          previo consenso dell&apos;utente, con aggiornamento della presente policy.
        </p>

        <h2>Gestione preferenze</h2>
        <p>
          Puoi gestire o bloccare i cookie direttamente dal browser. La
          disattivazione dei cookie tecnici potrebbe compromettere alcune
          funzionalit&agrave; essenziali del sito.
        </p>

        <h2>Contatti</h2>
        <p>
          Per informazioni sui cookie e sul trattamento dei dati: {" "}
          <a href="mailto:info@luxastudio.it">info@luxastudio.it</a>
        </p>

        <p>Ultimo aggiornamento: 27 aprile 2026.</p>
      </div>
    </div>
  );
}
